import { render, staticRenderFns } from "./purchase_bill_list.vue?vue&type=template&id=210b1ccc&scoped=true"
import script from "./purchase_bill_list.vue?vue&type=script&lang=js"
export * from "./purchase_bill_list.vue?vue&type=script&lang=js"
import style0 from "./purchase_bill_list.vue?vue&type=style&index=0&id=210b1ccc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b1ccc",
  null
  
)

export default component.exports